// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'dev',
  endpointJson: 'https://dev-ap-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com/config-internal.json',
  configBasePath: 'https://dev-ap-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com',
  cesAPI: {
    apiKey: 'HtW1dtuyIezZs1TMc2uT3K3aoJ9FxfIyYvxy0o20'
  },
  cognito: {
    userPoolId: 'ap-southeast-1_VSA0oEEsL',
    clientId: '36e0v5ngcg621cbm23f7k7fqoj',
    identityPoolId: 'ap-southeast-1:cabb1403-9ff6-438f-80c7-dc3a2d9aee23',
    region: 'ap-southeast-1',
    idpUrl: 'login.microsoftonline.com/548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
    azureAppId: 'af5baeee-b071-4a2f-a60d-a9bf426c841f',
  },
  siteUrl: 'https://dash-management.alpha.apac.gcds.coke.com/',
  internalHost: 'dev.internal.cds-ap.citko.net',
  publicHost: 'dev.cds-ap.citko.net',
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts